/** Первичная настройка — создание первого администратора (auth-and-roles). */
import { useState, type FormEvent } from 'react'
import { useAuth } from '@/app/auth-context'
import { AuthShell } from './auth-shell'
import { Field } from '@/design-system/components/primitives/field'
import { Input } from '@/design-system/components/primitives/input'
import { PasswordInput } from '@/design-system/components/primitives/password-input'
import { Button } from '@/design-system/components/primitives/button'
import { Alert } from '@/design-system/components/feedback/alert'
import { getErrorMessage } from '@/lib/errors'

export function SetupPage() {
  const { setupAdmin } = useAuth()
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await setupAdmin({ fullName, email, password })
    } catch (err) {
      setError(getErrorMessage(err, 'Не удалось создать администратора'))
      setSubmitting(false)
    }
  }

  return (
    <AuthShell subtitle="Первичная настройка — создание администратора">
      <form onSubmit={onSubmit} noValidate>
        {error ? (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        ) : null}
        <Field required label="ФИО администратора">
          {(props) => (
            <Input
              {...props}
              autoComplete="name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          )}
        </Field>
        <Field required label="Электронная почта">
          {(props) => (
            <Input
              {...props}
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          )}
        </Field>
        <Field required label="Пароль">
          {(props) => (
            <PasswordInput
              {...props}
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          )}
        </Field>
        <Button type="submit" className="mt-2 w-full justify-center" disabled={submitting}>
          {submitting ? 'Создание…' : 'Создать администратора'}
        </Button>
      </form>
    </AuthShell>
  )
}
